const state = {
    preWorkInfo: []
}
const getters = {
    preWorkInfo: (state) => { return state.preWorkInfo },
}
const mutations = {
    setPreWorkInfo: (state, data) => { state.preWorkInfo = data },

}
const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
};
